<template>
  <ValidationObserver ref="form" v-slot="{ handleSubmit }">
    <form
      class="mt-4"
      novalidate
      @submit.prevent="handleSubmit(onSubmit)"
      data-cy="reset-password-form"
    >
      <ValidationProvider
        vid="email"
        name="E-mail"
        rules="required|email"
        v-slot="{ errors }"
      >
        <div class="form-group">
          <label for="emailInput">Email address</label>
          <input
            type="email"
            :class="
              'form-control mb-0' + (errors.length > 0 ? ' is-invalid' : '')
            "
            id="emailInput"
            data-cy="email-input"
            aria-describedby="emailHelp"
            v-model="email"
            placeholder="Enter email"
            required
            :disabled="loading"
          />
          <div class="invalid-feedback">
            <span>{{ errors[0] }}</span>
          </div>
        </div>
      </ValidationProvider>
      <ValidationProvider
        vid="resetCode"
        name="Reset Code"
        rules="required"
        v-slot="{ errors }"
      >
        <div class="form-group">
          <label for="resetCodeInput">Reset code</label>
          <input
            type="text"
            :class="
              'form-control mb-0' + (errors.length > 0 ? ' is-invalid' : '')
            "
            id="resetCodeInput"
            data-cy="reset-code-input"
            v-model="resetCode"
            placeholder="Reset code"
            required
            :disabled="loading"
          />
          <div class="invalid-feedback">
            <span>{{ errors[0] }}</span>
          </div>
        </div>
      </ValidationProvider>
      <ValidationProvider
        vid="newPassword"
        name="New Password"
        rules="required"
        v-slot="{ errors }"
      >
        <div class="form-group">
          <label for="passwordInput">New Password</label>
          <input
            type="password"
            :class="
              'form-control mb-0' + (errors.length > 0 ? ' is-invalid' : '')
            "
            id="passwordInput"
            data-cy="password-input"
            v-model="newPassword"
            placeholder="New password"
            required
            :disabled="loading"
          />
          <div class="invalid-feedback">
            <span>{{ errors[0] }}</span>
          </div>
        </div>
      </ValidationProvider>
      <div class="d-inline-block w-100">
        <button
          v-if="!loading"
          type="submit"
          data-cy="submit-button"
          class="btn btn-primary float-right"
        >
          Set password
        </button>
        <button
          v-if="loading"
          type="submit"
          class="btn btn-primary float-right"
          disabled
        >
          Setting reset password...
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { resetPassword } from "../../../../Utils/auth";
export default {
  name: "ResetPasswordForm",
  data() {
    return {
      email: "",
      resetCode: "",
      newPassword: "",
      loading: false
    };
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      try {
        await resetPassword(this.email, this.resetCode, this.newPassword);
        this.loading = false;
        this.$toast.success(`Password changed`);
        this.$router.push("/auth/login");
      } catch (error) {
        this.loading = false;
        this.$toast.error(`Failed to reset password: ${error.message}`);
      }
    }
  }
};
</script>
